export type CurrencyInfo = {
	NumberOfDecimals: number;
};

export function fromCents(amountInCents: number, currency: CurrencyInfo): number {
	return amountInCents / Math.pow(10, currency.NumberOfDecimals);
}

export function toCents(amount: number, currency: any): number {
	return Math.round(amount * Math.pow(10, currency.NumberOfDecimals));
}
